"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTableConfig = void 0;

var _react = require("react");

var _useTableSelection2 = require("./useTableSelection");

var _utils = require("../../../utils");

var _useDraggable = require("../../../hooks/useDraggable");

var _utils2 = require("../utils/utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useTableConfig = function useTableConfig(_ref) {
  var pagingSource = _ref.paging,
      columnsSource = _ref.columns,
      sortingSource = _ref.sorting,
      filteringSource = _ref.filtering,
      defaultExpandAllRows = _ref.defaultExpandAllRows,
      expandedRowKeys = _ref.expandedRowKeys,
      orderColumns = _ref.orderColumns,
      expandedColumn = _ref.expandedColumn,
      table = _ref.table,
      dataSource = _ref.dataSource,
      data = _ref.data,
      rowSelection = _ref.rowSelection;

  // Expanded Row Keys
  var _useState = (0, _react.useState)(expandedRowKeys || []),
      _useState2 = _slicedToArray(_useState, 2),
      expandedRows = _useState2[0],
      setExpandedRows = _useState2[1];

  var expandOnClick = function expandOnClick(key) {
    setExpandedRows(function (old) {
      if (old.includes(key)) return old.filter(function (item) {
        return item !== key;
      });
      return [].concat(_toConsumableArray(old), [key]);
    });
  };

  (0, _react.useEffect)(function () {
    if (expandedRowKeys) setExpandedRows(expandedRowKeys);
  }, [expandedRowKeys]);
  (0, _react.useEffect)(function () {
    if (defaultExpandAllRows) setExpandedRows((0, _utils2.collectExpandedRows)(dataSource));
  }, [dataSource]); // Table Selection

  var _useTableSelection = (0, _useTableSelection2.useTableSelection)(rowSelection),
      selectionConfig = _useTableSelection.selectionConfig; // Columns


  var _useState3 = (0, _react.useState)(columnsSource),
      _useState4 = _slicedToArray(_useState3, 2),
      columns = _useState4[0],
      setColumns = _useState4[1];

  var changeColumns = function changeColumns(values) {
    setColumns(function (arr) {
      return arr.map(function (item) {
        return item.titleType ? item : _objectSpread(_objectSpread({}, item), {}, {
          hidden: !values.includes(item.key)
        });
      });
    });
  };

  (0, _react.useEffect)(function () {
    setColumns((0, _utils2.collectColumns)(columnsSource, data, expandedColumn, expandOnClick, orderColumns, selectionConfig));
  }, [columnsSource, orderColumns, selectionConfig.selectedRowKeys]); // Drag&Drop

  var dragEnd = function dragEnd(fromIndex, toIndex) {
    var columnsCopy = columns.slice();
    var columnsVisible = columns.filter(function (_ref2) {
      var hidden = _ref2.hidden;
      return !hidden;
    }).slice();
    var itemVisibleFrom = columnsVisible[fromIndex];
    var indexFrom = columnsCopy.findIndex(function (_ref3) {
      var key = _ref3.key;
      return key === itemVisibleFrom.key;
    });
    var itemFrom = columnsCopy[indexFrom];
    var itemVisibleTo = columnsVisible[toIndex];
    var indexTo = columnsCopy.findIndex(function (_ref4) {
      var key = _ref4.key;
      return key === itemVisibleTo.key;
    });
    if (itemFrom.dragDisabled) return;
    columnsCopy.splice(indexFrom, 1);
    columnsCopy.splice(indexTo, 0, itemFrom);
    setColumns(columnsCopy);
  };

  var last = columns.length - 1;
  var isLastDisabled = (0, _react.useCallback)(function (target) {
    return (0, _utils.getDomIndex)(target) === last && columns[last].dragDisabled;
  }, [columns]);
  var isFirstDisabled = (0, _react.useCallback)(function (target) {
    return (0, _utils.getDomIndex)(target) === 0 && columns[0].dragDisabled;
  }, [columns]);
  var isDisabled = (0, _react.useCallback)(function (target) {
    return isLastDisabled(target) || isFirstDisabled(target);
  }, [columns]);
  var onMouseDown = (0, _react.useCallback)(!orderColumns ? function () {} : (0, _useDraggable.useDraggable)(dragEnd, table.current, '.Table', ['th', 'td'], ['th'], isDisabled, ['th']), [orderColumns, table.current, isDisabled]); // Filtering

  var _useState5 = (0, _react.useState)(filteringSource || []),
      _useState6 = _slicedToArray(_useState5, 2),
      filtering = _useState6[0],
      setFiltering = _useState6[1];

  var changeFiltering = function changeFiltering(filter) {
    var newFiltering = filtering.filter(function (_ref5) {
      var key = _ref5.key;
      return key !== filter.key;
    });
    if (filter.value.length) setFiltering([].concat(_toConsumableArray(newFiltering), [filter]));else setFiltering(newFiltering);
  }; // Sorting


  var _useState7 = (0, _react.useState)(sortingSource || {}),
      _useState8 = _slicedToArray(_useState7, 2),
      sorting = _useState8[0],
      setSorting = _useState8[1];

  (0, _react.useEffect)(function () {
    if (!sorting.key) setSorting((0, _utils2.getSortingFromColumns)(columnsSource));
  }, [columnsSource]); // Paging

  var _useState9 = (0, _react.useState)(pagingSource || {}),
      _useState10 = _slicedToArray(_useState9, 2),
      paging = _useState10[0],
      setPaging = _useState10[1];

  var _useState11 = (0, _react.useState)(data.length),
      _useState12 = _slicedToArray(_useState11, 2),
      pagingTotal = _useState12[0],
      setPagingTotal = _useState12[1];

  var changePagination = function changePagination(currentPage) {
    setPaging(function (obj) {
      return _objectSpread(_objectSpread({}, obj), {}, {
        currentPage: currentPage
      });
    });
  };

  (0, _react.useEffect)(function () {
    if (pagingSource) setPaging(_objectSpread({
      currentPage: 1
    }, pagingSource));
  }, [pagingSource]);
  (0, _react.useEffect)(function () {
    if (pagingSource && pagingSource.total) setPagingTotal(pagingSource.total);
  }, [pagingSource]);
  (0, _react.useEffect)(function () {
    if (pagingTotal !== data.length && paging.currentPage) setPagingTotal(data.length);
  }, [data]);
  return {
    paging: paging,
    pagingTotal: pagingTotal,
    columns: columns,
    sorting: sorting,
    filtering: filtering,
    expandedRows: expandedRows,
    expandOnClick: expandOnClick,
    changeColumns: changeColumns,
    changeSorting: setSorting,
    changeFiltering: changeFiltering,
    changePagination: changePagination,
    changePaginationTotal: setPagingTotal,
    onMouseDown: onMouseDown
  };
};

exports.useTableConfig = useTableConfig;